module.exports = __webpack_public_path__ + "static/img/rolo.0e6040f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tools/rolo.png
// module id = 458
// module chunks = 1